const faqItems = [
  {
    q: '吃瓜网站主要提供哪些内容？',
    a: '吃瓜网站聚焦网红明星精品爆料，每日更新最新八卦内幕、综艺幕后、直播翻车、恋情曝光等独家吃瓜内容。我们覆盖国产51精品入口吃瓜爆料与网红最新爆料，是您了解娱乐圈动态的首选平台。',
  },
  {
    q: '网站的内容多久更新一次？',
    a: '网红吃瓜吃料网每日爆料，我们保持7×24小时不间断追踪。每天至少更新50条以上精品爆料内容，确保您不会错过任何热门吃瓜事件。',
  },
  {
    q: '如何投稿或提供爆料线索？',
    a: '您可以通过本页的「爆料投稿」入口联系我们，提交您掌握的独家内幕或八卦线索。我们重视每一位瓜友的爆料，核实后将标注来源并发布。',
  },
  {
    q: '吃瓜网站的内容可信度如何？',
    a: '我们坚持从多渠道交叉验证信息，所有精品吃瓜内幕均标注信息来源。对于未经证实的传闻，我们会明确标注「待核实」，让读者自行判断。',
  },
  {
    q: '手机上可以浏览吃瓜网站吗？',
    a: '当然可以！吃瓜网站完美适配移动端浏览，您也可以下载吃瓜APP获得更流畅的阅读体验。详情请查看本页「吃瓜APP」专区。',
  },
];

export default function FAQSection() {
  return (
    <section id="faq" className="py-12 md:py-16 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-4xl mx-auto">
        <h2 className="text-xl md:text-2xl font-heading text-foreground-950 mb-2">常见问答</h2>
        <p className="text-sm text-foreground-500 mb-8">关于吃瓜网站，你想知道的都在这里</p>
        <div className="flex flex-col gap-3">
          {faqItems.map((item, idx) => (
            <details key={idx} className="group bg-background-100 rounded-lg border border-background-200/70 overflow-hidden">
              <summary className="flex items-center justify-between px-5 py-4 cursor-pointer list-none">
                <h3 className="text-sm font-semibold text-foreground-900 pr-4">{item.q}</h3>
                <span className="flex-shrink-0 w-6 h-6 flex items-center justify-center rounded-full bg-background-200/70 group-open:bg-primary-100 transition-colors">
                  <i className="ri-arrow-down-s-line text-foreground-500 group-open:text-primary-600 text-sm transition-transform group-open:rotate-180"></i>
                </span>
              </summary>
              <div className="px-5 pb-4">
                <p className="text-sm text-foreground-600 leading-relaxed">{item.a}</p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}